
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.list-container {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.list-container .list-activator {
  display: inline-block;
  cursor: pointer;
  position: relative;
}
.list-container .list-items {
  position: absolute;
  right: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-6px) scale(0.97);
  transition: opacity 150ms ease-out, transform 150ms ease-out;
  padding: 16px 4px;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  border-radius: 16px;
  width: max-content;
  z-index: 1000;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  scrollbar-width: thin;
  scrollbar-color: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
}
.list-container .list-items::-webkit-scrollbar {
  width: 4px;
}
.list-container .list-items::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
  width: 4px;
}
.list-container .list-items::-webkit-scrollbar-thumb {
  background-color: var(--slh-color-neutral-shade-40, #C0C8D8);
  border-radius: 50px;
}
.list-container.open .list-items {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
}

@media (max-width: 560px) {
  .list-container {
    display: flex;
    position: unset;
  }
  .list-container .list-activator {
    width: 100%;
  }
  .list-container .list-activator span {
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
  }
  .list-container .list-items {
    width: 100vw !important;
    margin-top: 8px;
    border-radius: 0 0 16px 16px;
  }
}
*:focus {
  outline: none;
}

.list span:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 8px;
}
`;
